export const cookie = {
  get: (key: string): any => {
    const cookies = document.cookie
      .split("; ")
      .filter(Boolean)
      .reduce((acc, c) => {
        const [k, ...v] = c.split("=");
        acc[decodeURIComponent(k)] = decodeURIComponent(v.join("="));
        return acc;
      }, {} as Record<string, string>);

    const value = cookies[key];
    if (value === undefined) return null;

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  },

  set: (key: string, value: any, options?: any) => {
    const serialized =
      typeof value === "string" ? value : JSON.stringify(value);

    let cookieStr = `${encodeURIComponent(key)}=${encodeURIComponent(
      serialized
    )}; Secure`;
    cookieStr += `; Path=${options?.path ?? "/"}; Secure`;
    if (options?.domain) cookieStr += `; Domain=${options.domain}; Secure`;
    if (options?.maxAge) cookieStr += `; Max-Age=${options.maxAge}; Secure`;
    if (options?.expires)
      cookieStr += `; Expires=${options.expires.toUTCString()}; Secure`;
    if (options?.secure) cookieStr += `; Secure`;
    if (options?.sameSite) cookieStr += `; SameSite=${options.sameSite}; Secure`;

    document.cookie = cookieStr;
  },

  remove: (key: string) => {
    document.cookie = `${encodeURIComponent(key)}=; Max-Age=0; Path=/; Secure`;
  },
  removeWithOption: (key: string, options?: any) => {
    let str = `${encodeURIComponent(key)}=; Max-Age=0; Secure`;
    str += `; Path=${options?.path ?? "/"}; Secure`;
    if (options?.domain) str += `; Domain=${options.domain}; Secure`;
    if (options?.secure) str += `; Secure`;
    if (options?.sameSite) str += `; SameSite=${options.sameSite}; Secure`;

    document.cookie = str;
  }
};
